import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import {
    Card,
    Text,
    SkeletonItem,
    ButtonGroup,
    DaButton,
    ContractIcon,
} from '@paygreen/paygreen-ui';
import { ErrorBoundary } from '../../../components';

/**
 * @description - card to display customly user info with LineKeyValue component
 */
const OtherBillingCard = ({
    t,
    blockWidth,
    isLoading,
    space,
    accountId,
    organisationName,
}) => (
    <ErrorBoundary>
        <SkeletonItem
            blockHeight="auto"
            colorWab="grey10"
            radiusSize="sm"
            isLoading={isLoading}
        >
            <Card
                isShadowWab={true}
                blockWidth={blockWidth}
                paddingBottom="sm"
                paddingTop="sm"
                paddingLateral="sm"
            >
                <Text isResponsive={false} textSize="xs">
                    {t(`admin.billing.${space}.otherInvoice`)}
                </Text>

                <ButtonGroup align="center" marginTop="sm">
                    <RouterLink
                        to={{
                            pathname: `/admin/users/${accountId}/${space}-billing`,
                            state: {
                                organisationName: organisationName,
                                hasOtherSpaceBilling: true,
                            },
                        }}
                    >
                        <DaButton
                            buttonStyle="line"
                            gradient="theme"
                            colorTheme={
                                space === 'climate' ? 'primary' : 'quaternary'
                            }
                            buttonSize="sm"
                            icon={<ContractIcon />}
                        >
                            {t(`admin.billing.${space}.title`)}
                        </DaButton>
                    </RouterLink>
                </ButtonGroup>
            </Card>
        </SkeletonItem>
    </ErrorBoundary>
);

OtherBillingCard.propTypes = {
    isLoading: PropTypes.bool,
    space: PropTypes.string.isRequired,
    accountId: PropTypes.string.isRequired,
    blockWidth: PropTypes.string.isRequired,
    organisationName: PropTypes.string.isRequired,
};

OtherBillingCard.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(OtherBillingCard);
